// Contract between WidgetHelskarmLayer and widgets that cannot simply be
// CSS-zoomed. The layer announces every fullscreen change of a widget frame;
// `zoom` is the enlargement applied to the frame's content (1 = back on the
// page). GeoGebra listens: its hit-testing ignores CSS zoom, so the applet
// cancels the zoom for itself and grows to real pixels instead.

export const WIDGET_HELSKARM_EVENT = "widget-helskarm";

export type WidgetHelskarmDetail = { widget: HTMLElement; zoom: number };

export function annonseraHelskarm(widget: HTMLElement, zoom: number) {
  window.dispatchEvent(
    new CustomEvent<WidgetHelskarmDetail>(WIDGET_HELSKARM_EVENT, { detail: { widget, zoom } }),
  );
}
